module.exports = __webpack_public_path__ + "img/arrow-up-wide-short.c792e55f.svg";